// extracted by mini-css-extract-plugin
export default {"strip":"_3qWLC"};